var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 360v24h-48V97.9l-95 95-17 17L86.1 176l17-17L239 23l17-17 17 17 136 136 17 17-34 33.9-17-17-95-95zm32-8v-48h200v208H0V304h200v48H48v112h416V352zm72 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0"
  })));
};
export default SvgUpload;